// A copy of the default student messages as-of April 15, 2019, jslib 1.0.0
import { studentMessages } from './en-US';

// Aaron's preview account, student program
export const programId = '5f9329ae99f0f018aa9ca884';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    // useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': studentMessages,
    },
};
